import { render } from "./Shells.vue?vue&type=template&id=6953419a&scoped=true"
import script from "./Shells.js?vue&type=script&lang=js"
export * from "./Shells.js?vue&type=script&lang=js"

import "./Shells.vue?vue&type=style&index=0&id=6953419a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6953419a"]])

export default __exports__